
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/elchemy-tech/intl",
      function () {
        return require("private-next-pages/elchemy-tech/intl/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/elchemy-tech/intl"])
      });
    }
  